import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { HoldNotesCell } from "../cells/hold-notes-cell";

const catalogEntry = fgColumnEntries["hold-notes"];

export const HoldNotesColumn: Column2<FulfillmentGroupData> = {
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }) => <HoldNotesCell row={row} />,
  width: catalogEntry.defaultWidth,
  alignment: ColumnAlignment.LEFT,
};
